import { APIURL } from './../constant'
import http from './../interceptors/http-interceptor'
/* @purpose: check login.
@params: user_id, password
  @response: return login response.
  */
export function forgotPassword(user_id) {
  return http.post(`${APIURL}/forgot-password`, { user_id })
}
